import React from 'react';

const SalesAndFestivalsTimeline = () => {
  const timelineData = [
    {
      month: 'January',
      date: '6 Jan 2024',
      items: [
        {
          name: 'Ultra Slim LED Display',
          qty: 'Qty Sold: 1.90',
          revenue: 'Revenue: ₹42,500.00'
        },
        {
          name: 'prestige 1.5 l',
          qty: 'Qty Sold: 1.50',
          revenue: 'Revenue: ₹4,600.00'
        },
        {
          name: 'Sandwich',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹99.00'
        },
        {
          name: 'SERVICE',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹5,000.00'
        },
        {
          name: 'GAS 19 KG',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹850.00'
        }
      ]
    },
    {
      month: 'February',
      date: '14 Feb 2024',
      items: [
        {
          name: 'Maha Shivratri',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹34.00'
        },
        {
          name: 'Aqua Ezi',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹84.00'
        },
        {
          name: 'FUN',
          qty: 'Qty Sold: 12.00',
          revenue: 'Revenue: ₹84.00'
        },
        {
          name: 'Sanitize',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹21.00'
        },
        {
          name: 'prestige 1.5 l',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹1,500.00'
        },
        {
          name: 'GAS 19 KG',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹850.00'
        }
      ]
    },
    {
      month: 'March',
      date: '30 Mar 2024',
      items: [
        {
          name: 'Holi',
          qty: 'Qty Sold: 105.00',
          revenue: 'Revenue: ₹700.00'
        },
        {
          name: 'BEAR SHOCK ABSORBER ET005',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹1,300.00'
        },
        {
          name: 'prestige 1.5 l',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹1,500.00'
        },
        {
          name: 'CABINET',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹4,800.00'
        },
        {
          name: 'FRONT BUMPER',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹1,200.00'
        }
      ]
    },
    {
      month: 'April',
      date: '14 Apr 2024',
      items: [
        {
          name: 'Tamil New Year',
          qty: '',
          revenue: ''
        },
        {
          name: 'BEAR SHOCK ABSORBER ET005',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹2,500.00'
        },
        {
          name: 'FUN',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹12.00'
        },
        {
          name: 'SERVICE',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹5,000.00'
        },
        {
          name: 'prestige 1.5 l',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹74.00'
        }
      ]
    },
    {
      month: 'May',
      date: '',
      items: [
        {
          name: 'prestige 1.5 l',
          qty: 'Qty Sold: 17.00',
          revenue: 'Revenue: ₹171.00'
        },
        {
          name: 'Ultra Slim LED Display',
          qty: 'Qty Sold: 15.00',
          revenue: 'Revenue: ₹1,500.00'
        },
        {
          name: 'Aqua Ezi',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹11.00'
        },
        {
          name: 'mango',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹60.00'
        },
        {
          name: 'GAS 19 KG',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹1,000.00'
        }
      ]
    },
    {
      month: 'June',
      date: '',
      items: [
        {
          name: 'Jagannath Ratha Yatra',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹1,500.00'
        },
        {
          name: 'FUN',
          qty: 'Qty Sold: 300.00',
          revenue: 'Revenue: ₹1,800.00'
        },
        {
          name: 'ultra book cement 20kg',
          qty: 'Qty Sold: 20.00',
          revenue: 'Revenue: ₹1,300.00'
        },
        {
          name: 'INDIAN CLOSET',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹60,750.00'
        },
        {
          name: 'prestige 1.5 l',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹2,500.00'
        }
      ]
    },
    {
      month: 'December',
      date: '25 Dec 2024',
      items: [
        {
          name: 'Christmas',
          qty: '',
          revenue: ''
        },
        {
          name: 'prestige 1.5 l',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹275,000.00'
        },
        {
          name: 'GAS 19 KG',
          qty: 'Qty Sold: 1.00',
          revenue: 'Revenue: ₹1,200.00'
        }
      ]
    }
  ];

  const containerStyle = {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f5f5f5',
    padding: '20px',
    minHeight: '100vh'
  };

  const titleStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '20px',
    textAlign: 'left'
  };

  const timelineStyle = {
    position: 'relative',
    maxWidth: '800px',
    margin: '0 auto'
  };

  const timelineLineStyle = {
    position: 'absolute',
    left: '50%',
    top: '0',
    bottom: '0',
    width: '4px',
    backgroundColor: '#8B5CF6',
    transform: 'translateX(-50%)',
    zIndex: 1
  };

  const monthContainerStyle = {
    display: 'flex',
    marginBottom: '30px',
    position: 'relative'
  };

  const monthBoxStyle = {
    backgroundColor: 'white',
    border: '2px solid #8B5CF6',
    borderRadius: '8px',
    padding: '15px',
    width: '300px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    position: 'relative',
    zIndex: 2
  };

  const leftMonthStyle = {
    ...monthBoxStyle,
    marginRight: 'auto',
    marginLeft: '20px'
  };

  const rightMonthStyle = {
    ...monthBoxStyle,
    marginLeft: 'auto',
    marginRight: '20px'
  };

  const monthHeaderStyle = {
    backgroundColor: '#8B5CF6',
    color: 'white',
    padding: '10px',
    margin: '-15px -15px 15px -15px',
    borderRadius: '6px 6px 0 0',
    fontSize: '14px',
    fontWeight: 'bold'
  };

  const dateStyle = {
    backgroundColor: '#8B5CF6',
    color: 'white',
    padding: '8px',
    margin: '0 -15px 15px -15px',
    fontSize: '12px',
    fontWeight: 'bold'
  };

  const itemStyle = {
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
    padding: '8px',
    marginBottom: '8px',
    borderRadius: '4px',
    fontSize: '11px'
  };

  const itemNameStyle = {
    fontWeight: 'bold',
    marginBottom: '4px',
    fontSize: '12px'
  };

  const itemDetailStyle = {
    color: '#666',
    fontSize: '10px',
    marginBottom: '2px'
  };

  const timelineDotStyle = {
    position: 'absolute',
    width: '12px',
    height: '12px',
    backgroundColor: '#8B5CF6',
    borderRadius: '50%',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 3
  };

  const timelineConnectorStyle = {
    position: 'absolute',
    top: '20px',
    height: '2px',
    backgroundColor: '#8B5CF6',
    zIndex: 2
  };

  const leftConnectorStyle = {
    ...timelineConnectorStyle,
    right: '50%',
    width: 'calc(50% - 320px)'
  };

  const rightConnectorStyle = {
    ...timelineConnectorStyle,
    left: '50%',
    width: 'calc(50% - 320px)'
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>SALES AND FESTIVALS TIMELINE</h1>
      <div style={timelineStyle}>
        <div style={timelineLineStyle}></div>
        
        {timelineData.map((month, index) => (
          <div key={index} style={monthContainerStyle}>
            <div style={timelineDotStyle}></div>
            
            {index % 2 === 0 ? (
              <>
                <div style={leftConnectorStyle}></div>
                <div style={leftMonthStyle}>
                  <div style={monthHeaderStyle}>{month.month}</div>
                  {month.date && <div style={dateStyle}>{month.date}</div>}
                  {month.items.map((item, itemIndex) => (
                    <div key={itemIndex} style={itemStyle}>
                      <div style={itemNameStyle}>{item.name}</div>
                      {item.qty && <div style={itemDetailStyle}>{item.qty}</div>}
                      {item.revenue && <div style={itemDetailStyle}>{item.revenue}</div>}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div style={rightConnectorStyle}></div>
                <div style={rightMonthStyle}>
                  <div style={monthHeaderStyle}>{month.month}</div>
                  {month.date && <div style={dateStyle}>{month.date}</div>}
                  {month.items.map((item, itemIndex) => (
                    <div key={itemIndex} style={itemStyle}>
                      <div style={itemNameStyle}>{item.name}</div>
                      {item.qty && <div style={itemDetailStyle}>{item.qty}</div>}
                      {item.revenue && <div style={itemDetailStyle}>{item.revenue}</div>}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesAndFestivalsTimeline;